import * as types from '../../actions/actionTypes';
import initialState from '../initialState';

export const deDistributeReducer = (
  state = initialState.deDistribute,
  action
) => {
  switch (action.type) {
    case types.GET_DE_DESTINATION_REQUEST: {
      return {
        ...state,
        destinations: {
          ...state.destinations,
          isLoading: true,
          isError: false,
        },
      };
    }
    case types.GET_DE_DESTINATION_FAILURE: {
      return {
        ...state,
        destinations: {
          ...state.destinations,
          isLoading: false,
          isError: true,
        },
      };
    }
    case types.GET_DE_DESTINATION_SUCCESS: {
      return {
        ...state,
        destinations: {
          ...state.destinations,
          isLoading: false,
          isError: false,
          data: action.response,
        },
      };
    }
    case types.GET_DE_CAMPAIGNLIST_REQUEST: {
      return {
        ...state,
        distributeData: {
          ...state.distributeData,
          isLoading: true,
          isError: false,
        },
      };
    }
    case types.GET_DE_CAMPAIGNLIST_FAILURE: {
      return {
        ...state,
        distributeData: {
          ...state.distributeData,
          isLoading: false,
          isError: true,
        },
      };
    }
    case types.GET_DE_CAMPAIGNLIST_SUCCESS: {
      return {
        ...state,
        distributeData: {
          ...state.distributeData,
          isLoading: false,
          isError: false,
          data: action.response,
        },
      };
    }
    case types.GET_DE_CAMPAIGNLIST_UPDATED: {
      return {
        ...state,
        updatedCampaign: action.updatedCampaign,
      };
    }
    case types.SET_DE_DIST_REQUEST_NAME: {
      return {
        ...state,
        distRequest: {
          ...state.distRequest,
          name: action.reqName,
        },
      };
    }
    case types.DE_DIST_ADD_TO_QUEUE_NAME_ERR: {
      return {
        ...state,
        distErrors: {
          ...state.distErrors,
          isNameErr: true,
          isNameErrMsg: action.isErrMsg,
        },
      };
    }
    case types.DE_DIST_ADD_TO_QUEUE_NAME_ERR_RESET: {
      return {
        ...state,
        distErrors: {
          ...state.distErrors,
          isNameErr: false,
          isNameErrMsg: '',
        },
      };
    }
    case types.DE_DIST_ADD_TO_QUEUE_TARGET_ERR: {
      return {
        ...state,
        distErrors: {
          ...state.distErrors,
          isTargetErr: true,
          isTargetErrMsg: action.isErrMsg,
        },
      };
    }
    case types.DE_DIST_ADD_TO_QUEUE_TARGET_ERR_RESET: {
      return {
        ...state,
        distErrors: {
          ...state.distErrors,
          isTargetErr: false,
          isTargetErrMsg: '',
        },
      };
    }
    case types.DE_DIST_ADD_TO_QUEUE_DATE_ERR: {
      return {
        ...state,
        distErrors: {
          ...state.distErrors,
          isDateErr: true,
          isDateErrMsg: action.isErrMsg,
        },
      };
    }
    case types.DE_DIST_ADD_TO_QUEUE_DATE_ERR_RESET: {
      return {
        ...state,
        distErrors: {
          ...state.distErrors,
          isDateErr: false,
          isDateErrMsg: '',
        },
      };
    }
    case types.SET_DE_DIST_FROM_TO_DATE: {
      return {
        ...state,
        distRequest: {
          ...state.distRequest,
          startDate: action.fromDate,
          endDate: action.toDate,
        },
      };
    }
    case types.SET_DE_DIST_FOR_ACTIVATION: {
      return {
        ...state,
        distRequest: {
          ...state.distRequest,
          isForActivation: action.activationState,
          startDate: null,
          endDate: null,
        },
        distErrors: {
          ...state.distErrors,
          isDateErr: false,
          isDateErrMsg: '',
        },
      };
    }
    case types.SET_TARGET_DISTRIBUTE: {
      return {
        ...state,
        selectedTarget: action.payload,
      };
    }
    case types.RESET_DE_DISTRIBUTE: {
      return {
        ...state,
        ...initialState.deDistribute,
      };
    }
    case types.SET_CAMPAIGN_DETAILS: {
      return {
        ...state,
        distRequest: action.payload || initialState.deDistribute.distRequest,
      };
    }
    case types.SET_CAMPAIGN_DETAILS_TEMP: {
      return {
        ...state,
        tempDistRequest:
          action.payload || initialState.deDistribute.tempDistRequest,
      };
    }
    case types.SET_TARGET_DISTRIBUTE_TEMP: {
      return {
        ...state,
        tempSelectedTarget:
          action.payload || initialState.deDistribute.tempSelectedTarget,
      };
    }
    case types.ASK_DE_REQUEST_CHANGES: {
      return {
        ...state,
        askForUnsavedChanges: action.payload,
      };
    }
    case types.SET_DISTRIBUTE_MODAL: {
      return {
        ...state,
        isDistributeModalOpen: action.currentState,
      };
    }
    case types.SET_DESTINATION_DETAILS: {
      return {
        ...state,
        distRequest: {
          ...state.distRequest,
          dest: action.payload,
        },
      };
    }
    case types.RESET_DE_DISTRIBUTE_ERRORS: {
      return {
        ...state,
        distErrors: initialState.deDistribute.distErrors,
      };
    }
    case types.SET_DE_DIST_DELETE_REQUEST: {
      return {
        ...state,
        isDeleteRequest: action.isDeleteRequest,
        isDeleteRequestId: action.isDeleteRequestId,
        isDeleteRequestName: action.isDeleteRequestName,
      };
    }
    case types.SET_DE_DELETE_CAMPAIGN_SUCCESS: {
      return {
        ...state,
        distributeData: {
          ...state.distributeData,
          data: action.payload,
        },
        distRequest: (action.distRequestReset) ? initialState.deDistribute.distRequest : state.distRequest,
      };
    }
    case types.SET_DE_DISTREQUEST_STATUS: {
      return {
        ...state,
        distRequest: {
          ...state.distRequest,
          status: action.status,
        },
      };
    }

    case types.SET_DE_DIST_CONFIRM_REQUEST: {
      return {
        ...state,
        isConfirmRequest: action.isConfirmRequest
      };
    }
    default:
      return state;
  }
};
